import React from 'react';
import PropTypes from 'prop-types';
// Core components
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
// HOCS
import withLoading from 'hocs/WithLoading';
// Custom
import {
  cpmWorkspaceDataShape,
  listRowSpecsShape,
} from 'constants/PropTypesShapes';
import { showPath } from 'cpmWorkspaces/navigation';
import { SelectIconButton } from 'components/buttons/IconButtons';

const WorkspaceRow = React.forwardRef(
  ({ workspace, rowSpecs, handleStartLoading }, ref) => (
    <TableRow
      ref={ref}
      element={workspace}
      rowSpecs={rowSpecs}
      actions={[
        <SelectIconButton key="btnSelect" onClick={handleStartLoading} path={showPath(workspace.id)} />,
      ]}
    >
      <TableCell>{workspace.name}</TableCell>
    </TableRow>
  ),
);

WorkspaceRow.displayName = 'WorkspaceRow';

WorkspaceRow.propTypes = {
  workspace: cpmWorkspaceDataShape.isRequired,
  rowSpecs: listRowSpecsShape.isRequired,
  handleStartLoading: PropTypes.func.isRequired,
};

module.exports = (withLoading)(WorkspaceRow);



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/assets/main/WorkspaceRow.js